import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChevronGrabberVerticalToward: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChevronGrabberVerticalToward"><Path d="M17.0605 18.75L16 19.8105L12 15.8105L8 19.8105L6.93945 18.75L12 13.6895L17.0605 18.75Z" fill="currentColor"/><Path d="M17.0605 5.25L12 10.3105L6.93945 5.25L8 4.18945L12 8.18945L16 4.18945L17.0605 5.25Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChevronGrabberVerticalToward;
